import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Flex, Box, Grid } from '../Box'
import { Button } from '../Button'
import { Link } from '../Link'
import { DarkMatterRound } from '../Png'
import { LogoIcon, VectorRightIcon } from '../Svg'
import { Text } from '../Text'
import { StyledFooter, StyledText } from './styles'
import { FooterProps } from './types'
import SocialLinks from './Components/SocialLinks'
import { Skeleton } from '../Skeleton'

const MenuItem: React.FC<FooterProps> = ({ items, isBlackThemePage, dmdPriceUsd, ...props }) => {
  return (
    <StyledFooter
      mt={isBlackThemePage ? '0px' : '150px'}
      p={['40px', null, null, null, '84px']}
      {...props}
      isBlackThemePage={isBlackThemePage}
    >
      <Box maxWidth="1440px" mx="auto">
        <Grid
          gridTemplateColumns={['1fr 1fr', null, null, null, '1fr 1fr 1fr 1fr']}
          gridRowGap="48px"
          gridColumnGap="32px"
        >
          {items?.map((item) => (
            <Box key={item.label}>
              <Text fontSize="17px" fontWeight="600" mb="14px" color="primary">
                {item.label}
              </Text>
              {item.items?.map(({ label, href }) => (
                <Box key={label}>
                  {href ? (
                    <Link
                      href={href}
                      target="_blank"
                      rel="noreferrer noopener"
                      color="textSecondary"
                      fontSize="15px"
                      fontWeight="300"
                      mb="4px"
                    >
                      {label}
                    </Link>
                  ) : (
                    <StyledText>{label}</StyledText>
                  )}
                </Box>
              ))}
            </Box>
          ))}
          <Box>
            <Text fontSize="17px" fontWeight="600" mb="14px" color="primary">
              Social
            </Text>
            <SocialLinks order={[2]} />
          </Box>
        </Grid>
        <Flex mt="100px" alignItems="center">
          <LogoIcon fill="#9112FF" mr="8px" width="15px" />
          <Text color="primary" fontSize="15px" fontWeight="500">
            DarkMatter Defi
          </Text>
        </Flex>
        <Flex
          alignItems={['start', null, 'center']}
          justifyContent="space-between"
          mt="32px"
          flexDirection={['column', null, 'row']}
        >
          <Flex alignItems="center">
            {dmdPriceUsd ? (
              <>
                <DarkMatterRound w="25px" m="0 12px 0 0" />
                <Text color="textSecondary" fontSize="16px" fontWeight="700" mr="16px">{`$${dmdPriceUsd.toFixed(
                  3,
                )}`}</Text>
              </>
            ) : (
              <Skeleton mr="12px" width={80} height={24} />
            )}
            <Button
              as={RouterLink}
              to="/swap?outputCurrency=0x90e892fed501ae00596448aecf998c88816e5c0f"
              height="27px"
              variant="text"
              p="0"
              endIcon={<VectorRightIcon fill="rgba(255, 255, 255, 0.5)" />}
            >
              <Text fontSize="18px" fontWeight="500" color="textSecondary">
                Buy DMD
              </Text>
            </Button>
          </Flex>
          <Text color="textSecondary" fontSize="13px" fontWeight="300" mt={['36px', null, '0']}>
            Copyright © 2022 DarkMatter
          </Text>
        </Flex>
      </Box>
    </StyledFooter>
  )
}

export default MenuItem
